import React from "react";
import "./App.css";
import Home from "./pages/index";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import TableroPage from "./components/funtComponents/Pages/InicioPage";
import ConfigPage from "./components/funtComponents/Pages/ConfigPage";
import EntrantesPage from "./components/funtComponents/Pages/Entrantes";
import SalientesPage from "./components/funtComponents/Pages/Salientes";
import CombinadoPage from "./components/funtComponents/Pages/Combinado";
import DistribucionPage from "./components/funtComponents/Pages/Distribucion";
import UserPage from "./components/funtComponents/Pages/UserPage";
import AdminEditPage from "./components/funtComponents/Pages/AdminEditPage";
import AdminEditAnexo from "./components/funtComponents/Pages/AdminEditAnexo";
import AdminGeneradorReporte from "./components/funtComponents/Pages/AdminGeneradorReportePage";
import AdminEditarTarifaPage from "./components/funtComponents/Pages/AdminEditarTarifaPage";
import NotificacionPage from "./components/funtComponents/Pages/NotificationPage";
import AnexosDPage from "./components/funtComponents/Pages/AnexoDtails";

import FacturacionPage from "./pages/payments";
import rootReducer from "./redux/reducer/index";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
const middleware = applyMiddleware(thunk);
const store = createStore(rootReducer, middleware);

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/mimegacall">
        <Routes>
          <Route path="/" element={<Home />} >
            <Route path="/Tablero" element={<TableroPage />}  />
            <Route path="/Configuracion" element={<ConfigPage />}  />
            <Route path="/Entrantes" element={<EntrantesPage />}  />
            <Route path="/Salientes" element={<SalientesPage />}  />
            <Route path="/Combinado" element={<CombinadoPage />}  />
            <Route path="/Distribucion" element={<DistribucionPage />}  />
            <Route path="/Notificacion" element={<NotificacionPage />}  />
            <Route path="/UserPage" element={<UserPage />}  />
            <Route path="/AdminEdit" element={<AdminEditPage />}  />
            <Route path="/AdminEditAnexo" element={<AdminEditAnexo />}  />
            <Route
              path="/AdminGeneradorReporte"
              element={<AdminGeneradorReporte />}
              
            />
            <Route
              path="/AdminEditarTarifa"
              element={<AdminEditarTarifaPage />}
              
            />
            <Route path="/Facturacion" element={<FacturacionPage />}  />
            <Route path="/Detalle de Anexos" element={<AnexosDPage />}  />
             
              <Route path="/Configuracion"  element={<ConfigPage />} />
             
              <Route path="/Entrantes"  element={<EntrantesPage />} />
             
              <Route path="/Salientes"  element={<SalientesPage />} />
             
              <Route path="/Combinado"  element={<CombinadoPage />} />
             
             
              <Route path="/UserPage"  element={<UserPage />} />
             
              <Route path="/AdminEdit" element={<AdminEditPage />} />
              <Route path="/AdminEditAnexo"  element={<AdminEditAnexo />} />
              <Route path="/EditServicios"  element={<AdminEditAnexo />} />
             
             
             
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
